define('NMSDesignSystem.InitialHome.Shopping', ['Home.View', 'SC.CCT.Html.View', 'jQuery'], function(HomeView, CmsHtmlView, jQuery) {
    'use strict';

    function eligibleHome(view) {
        var doc = typeof window !== 'undefined' && window.document;
        var host = doc && window.location.hostname;
        return !!(doc && (host === 'nmsincusa.com' || host === 'www.nmsincusa.com' ||
            host === 'sca-sandbox.ethanablatt.com' || host === 'buyflushots.nmsincusa.com' ||
            host === 'buyflu-sandbox.ethanablatt.com') && window.location.pathname === '/' &&
            typeof SC !== 'undefined' && SC.isRehydrating === true && SC.ENVIRONMENT &&
            SC.ENVIRONMENT.jsEnvironment === 'browser' &&
            doc.querySelector('link[data-nms-critical-style]') && view.el &&
            view.options && view.options.el === view.el && view.el.id === 'home-page' &&
            ((host === 'buyflushots.nmsincusa.com' || host === 'buyflu-sandbox.ethanablatt.com') ?
                view.el.querySelector('.nms-bfs-hero #nms-bfs-hero-title') : view.el.querySelector('.home-main-slider-cms-container .alt-hero #hero-title')));
    }

    function homeNodes(nodes) {
        var roots = [], valid = true;
        Array.prototype.forEach.call(nodes || [], function(node) {
            if (node.nodeType === 8 || node.nodeType === 3 && !node.nodeValue.trim()) return;
            if (node.nodeType !== 1 || node.matches('script, iframe, object, form, input, select, textarea, [contenteditable], video, audio, canvas, details, summary') ||
                    node.querySelector('script, iframe, object, form, input, select, textarea, [contenteditable], video, audio, canvas, details, summary')) {
                valid = false;
                return;
            }
            var elements = [node].concat(Array.prototype.slice.call(node.querySelectorAll('*')));
            if (elements.some(function unsupportedElement(element) {
                    return element.shadowRoot || element.localName.indexOf('-') >= 0 ||
                        Array.prototype.some.call(element.attributes, function(attr) { return /^on/i.test(attr.name); });
                })) valid = false;
            roots.push(node);
        });
        return valid && roots.length ? roots : null;
    }

    function sameHomeContent(element, content) {
        var oldNodes = homeNodes(element.childNodes), freshNodes = homeNodes(content);
        return !!(oldNodes && freshNodes && oldNodes.length === freshNodes.length &&
            oldNodes.every(function identicalNode(node, index) { return node.isEqualNode(freshNodes[index]); }));
    }

    function retainIdenticalHeroRoot(element, content) {
        var buyFlu = ['buyflushots.nmsincusa.com', 'buyflu-sandbox.ethanablatt.com'].indexOf(window.location.hostname) >= 0;
        var rootClass = buyFlu ? 'nms-bfs-hero' : 'home-main-slider-cms-container';
        var oldRoots = Array.prototype.filter.call(element.children, function(node) {
            return node.classList.contains(rootClass);
        });
        var freshRoots = [];
        Array.prototype.forEach.call(content || [], function(node, index) {
            if (node.nodeType === 1 && node.classList.contains(rootClass)) {
                freshRoots.push({node: node, index: index});
            }
        });
        if (oldRoots.length !== 1 || freshRoots.length !== 1) return false;
        var oldRoot = oldRoots[0], fresh = freshRoots[0];
        var descriptor = Object.getOwnPropertyDescriptor(content, String(fresh.index));
        if (!descriptor || !descriptor.writable || (!buyFlu && oldRoot.getAttribute('data-cms-area') !== 'home-main-slider') ||
                oldRoot.querySelectorAll(buyFlu ? '#nms-bfs-hero-title' : '.alt-hero #hero-title').length !== 1 ||
                !homeNodes([oldRoot]) || !oldRoot.isEqualNode(fresh.node)) return false;
        // Keep the exact hero connected. Appending an already attached node also removes
        // and reinserts it, so replace only its siblings and leave this root in place.
        // Native composite rendering receives the retained root in its actual template.
        if (!homeNodes(content)) return false;
        var oldSiblings = Array.prototype.filter.call(element.childNodes, function(node) { return node !== oldRoot; });
        content[fresh.index] = oldRoot;
        oldSiblings.forEach(function(node) { jQuery(node).remove(); });
        var after = false;
        Array.prototype.forEach.call(content, function(node) {
            if (node === oldRoot) { after = true; return; }
            element.insertBefore(node, after ? null : oldRoot);
        });
        return true;
    }

    function sameInitialLayout(element, content, pageView) {
        var incoming = null;
        for (var i = 0; content && i < content.length; i += 1) {
            var node = content[i];
            if (node.nodeType === 8 || node.nodeType === 3 && !node.nodeValue.trim()) continue;
            if (incoming || node.nodeType !== 1) return false;
            incoming = node;
        }
        if (!incoming || element.id !== 'layout' || incoming.id !== 'layout' ||
                element.querySelector('#layout') || incoming.querySelector('#layout')) return false;
        var shellNodes = [element].concat(Array.prototype.slice.call(element.querySelectorAll('*')));
        if (shellNodes.some(function(node) { return node.shadowRoot || node.localName.indexOf('-') >= 0; })) return false;
        var oldContent = element.querySelectorAll('#content'), freshContent = incoming.querySelectorAll('#content');
        if (oldContent.length !== 1 || freshContent.length !== 1 ||
                oldContent[0].childElementCount !== 1 || oldContent[0].firstElementChild !== pageView.el ||
                !pageView.el.isConnected || freshContent[0].childElementCount !== 0 ||
                !homeNodes(pageView.el.childNodes)) return false;
        if (!Array.prototype.every.call(oldContent[0].childNodes, function knownSibling(node) {
                return node === pageView.el || node.nodeType === 8;
            }) || !Array.prototype.every.call(freshContent[0].childNodes, function emptyNode(node) {
                return node.nodeType === 8;
            })) return false;
        var before = element.cloneNode(true), after = incoming.cloneNode(true);
        before.querySelector('#content').textContent = '';
        after.querySelector('#content').textContent = '';
        return before.isEqualNode(after);
    }

    function retainExactCmsHero(hero, content) {
        var candidates = [];
        Array.prototype.forEach.call(content || [], function(node) {
            if (node.nodeType !== 1) return;
            if (node.matches('.alt-hero')) candidates.push(node);
            candidates = candidates.concat(Array.prototype.slice.call(node.querySelectorAll('.alt-hero')));
        });
        if (candidates.length !== 1 || !hero.parentNode || !homeNodes([hero]) ||
                !hero.isEqualNode(candidates[0]) || !candidates[0].parentNode) return false;
        candidates[0].parentNode.replaceChild(hero, candidates[0]);
        return true;
    }

    function installInitialCmsHero(application) {
        if (CmsHtmlView.prototype.nmsInitialHomeCmsInstalled) return;
        var nativeCmsRender = CmsHtmlView.prototype._render;
        CmsHtmlView.prototype._render = function renderInitialCmsHero() {
            var cmsView = this, doc = typeof window !== 'undefined' && window.document;
            var host = doc && window.location.hostname;
            var layout = application && application.getLayout && application.getLayout();
            var home = layout && layout.currentView;
            var eligible = doc && (host === 'nmsincusa.com' || host === 'www.nmsincusa.com' ||
                host === 'sca-sandbox.ethanablatt.com' || host === 'buyflushots.nmsincusa.com' ||
            host === 'buyflu-sandbox.ethanablatt.com') && window.location.pathname === '/' &&
                typeof SC !== 'undefined' && SC.ENVIRONMENT && SC.ENVIRONMENT.jsEnvironment === 'browser' &&
                cmsView.instanceId === 'CMS_HTML-1' && home && !home.nmsConnectedHomeCmsActive && home.el && home.el.id === 'home-page' &&
                (home.nmsInitialHomeRetained || home.nmsInitialHomeHeroRetained) &&
                !home.nmsInitialHomeCmsRenderAttempted;
            if (!eligible) return nativeCmsRender.apply(cmsView, arguments);
            home.nmsInitialHomeCmsRenderAttempted = true;
            var heroes = home.el.querySelectorAll('.home-main-slider-cms-container .alt-hero');
            if (heroes.length !== 1 || !homeNodes([heroes[0]])) return nativeCmsRender.apply(cmsView, arguments);
            var hero = heroes[0];
            // Keep every native CMS compile/render/event hook and all new wrapper/style markup.
            // Only the identical, inert first hero subtree can move into the incoming template.
            return renderKeepingIdenticalContent(cmsView, nativeCmsRender, arguments, function(element, content) {
                if (home.el.contains(hero) && retainExactCmsHero(hero, content)) {
                    home.nmsInitialHomeCmsHeroRetained = true;
                }
                return false;
            }, 'nmsInitialHomeCmsContentsRetained');
        };
        CmsHtmlView.prototype.nmsInitialHomeCmsInstalled = true;
    }

    function install(application) {
        if (HomeView.prototype.nmsInitialHomeInstalled) return;
        var nativeRender = HomeView.prototype._render, nativeShow = HomeView.prototype.showContent;
        HomeView.prototype._render = function renderInitialHome() {
            var view = this, app = view.options && view.options.application;
            var layout = app && app.getLayout && app.getLayout();
            var content = layout && layout.el && layout.el.querySelector('#content');
            var eligible = !view.nmsInitialHomeRenderAttempted && eligibleHome(view) &&
                layout && layout.currentView === view && layout.el.isConnected && content &&
                (view.el.isConnected ? view.el.parentElement === content : content.childElementCount === 0);
            view.nmsInitialHomeRenderAttempted = true;
            if (!eligible || !homeNodes(view.el.childNodes)) return nativeRender.apply(view, arguments);
            return renderKeepingIdenticalContent(view, nativeRender, arguments, sameHomeContent, 'nmsInitialHomeRetained');
        };
        HomeView.prototype.showContent = function showInitialHome() {
            var view = this, app = view.options && view.options.application;
            var layout = app && app.getLayout && app.getLayout();
            var eligible = !view.nmsInitialHomeShowAttempted && eligibleHome(view) &&
                !view.getHeaderView && !view.getFooterView && layout && !layout.currentView && layout.el && layout.el.isConnected &&
                view.el.isConnected && layout.getDOMContentElement && layout.getDOMContentElement() === view.el;
            view.nmsInitialHomeShowAttempted = true;
            if (!eligible) return nativeShow.apply(view, arguments);
            var descriptor = Object.getOwnPropertyDescriptor(layout, 'render');
            if (!Object.isExtensible(layout) || descriptor && (!descriptor.configurable || !descriptor.writable)) {
                return nativeShow.apply(view, arguments);
            }
            var layoutRender = layout.render, wrapped, installed = false, consumed = false;
            function restore() {
                if (!installed) return;
                installed = false;
                var current = Object.getOwnPropertyDescriptor(layout, 'render');
                if (!current || current.value !== wrapped) return;
                if (descriptor) Object.defineProperty(layout, 'render', descriptor);
                else delete layout.render;
            }
            try {
                Object.defineProperty(layout, 'render', {configurable: true, writable: true,
                    value: (wrapped = function renderInitialHomeLayout() {
                        if (consumed) return layoutRender.apply(this, arguments);
                        consumed = true;
                        restore();
                        if (this !== layout || !eligibleHome(view)) return layoutRender.apply(this, arguments);
                        return renderKeepingIdenticalContent(layout, layoutRender, arguments,
                            function sameShell(element, content) { return sameInitialLayout(element, content, view); },
                            'nmsInitialHomeLayoutRetained');
                    })});
                installed = true;
            } catch (installationError) { return nativeShow.apply(view, arguments); }
            try {
                var result = nativeShow.apply(view, arguments);
                if (result && typeof result.always === 'function') result.always(restore);
                else restore();
                return result;
            } catch (showError) { restore(); throw showError; }
        };
        installInitialCmsHero(application);
        HomeView.prototype.nmsInitialHomeInstalled = true;
    }

        function renderKeepingIdenticalContent(view, nativeRender, args, compare, retainedFlag) {
            var $element = view.$el;
            var element = $element[0];
            var emptyDescriptor = Object.getOwnPropertyDescriptor($element, 'empty');
            var appendDescriptor = Object.getOwnPropertyDescriptor($element, 'append');
            if (!Object.isExtensible($element) ||
                    (emptyDescriptor && (!emptyDescriptor.configurable || !emptyDescriptor.writable)) ||
                    (appendDescriptor && (!appendDescriptor.configurable || !appendDescriptor.writable))) {
                return nativeRender.apply(view, args);
            }
            var nativeEmpty = $element.empty;
            var nativeAppend = $element.append;
            var deferredEmpty = false;
            var pending = true;

            function flushEmpty() {
                if (deferredEmpty) {
                    deferredEmpty = false;
                    nativeEmpty.call($element);
                }
            }

            var deferInitialEmpty = function deferInitialEmpty() {
                if (this === $element && pending && !arguments.length) {
                    deferredEmpty = true;
                    pending = false;
                    return this;
                }
                flushEmpty();
                return nativeEmpty.apply(this, arguments);
            };
            var appendOrRetainIdenticalContent = function appendOrRetainIdenticalContent(content) {
                if (this === $element && deferredEmpty && arguments.length === 1) {
                    var identical = false;
                    try {
                        identical = compare(element, content);
                    } catch (comparisonError) {
                        // An unsupported or changed template always takes the native path.
                    }
                    if (identical) {
                        deferredEmpty = false;
                        view[retainedFlag] = true;
                        return this;
                    }
                    if (retainedFlag === 'nmsInitialHomeRetained' &&
                            retainIdenticalHeroRoot(element, content)) {
                        view.nmsInitialHomeHeroRetained = true;
                        deferredEmpty = false;
                        return this;
                    }
                }
                flushEmpty();
                return nativeAppend.apply(this, arguments);
            };
            function restoreMethods() {
                if (emptyDescriptor) {
                    Object.defineProperty($element, 'empty', emptyDescriptor);
                } else {
                    delete $element.empty;
                }
                if (appendDescriptor) {
                    Object.defineProperty($element, 'append', appendDescriptor);
                } else {
                    delete $element.append;
                }
            }
            try {
                try {
                    Object.defineProperty($element, 'empty', {
                        value: deferInitialEmpty, configurable: true, writable: true
                    });
                    Object.defineProperty($element, 'append', {
                        value: appendOrRetainIdenticalContent, configurable: true, writable: true
                    });
                } catch (installationError) {
                    restoreMethods();
                    return nativeRender.apply(view, args);
                }
                return nativeRender.apply(view, args);
            } finally {
                try {
                    flushEmpty();
                } finally {
                    restoreMethods();
                }
            }
        }

    return { mountToApp: install, renderKeepingIdenticalContent: renderKeepingIdenticalContent,
        sameInitialLayout: sameInitialLayout, inertNodes: homeNodes };
});
